import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import './index.css'
import '../styles/layout-overide.css'
import 'prismjs/themes/prism-tomorrow.css'

import Header from '../components/header'
const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        {
          name: 'description',
          content:
            'I am Stevica Knezevic, web developer who intensively follows new things and keeps up with latest technologies.',
        },
        {
          name: 'keywords',
          content:
            'Tech Blog, JavaScript, Node.js, Docker, TypeScript, React, Angular, AWS, Novi Sad',
        },
      ]}
    />
    <Header siteTitle={data.site.siteMetadata.title} />

    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js